import { render, staticRenderFns } from "./TransactionDate.vue?vue&type=template&id=452bfb8e&scoped=true&"
import script from "./TransactionDate.vue?vue&type=script&lang=js&"
export * from "./TransactionDate.vue?vue&type=script&lang=js&"
import style0 from "./TransactionDate.vue?vue&type=style&index=0&id=452bfb8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452bfb8e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
